import getConfig from 'next/config';
import get from 'lodash/get';
import flows from '../test-utils/flows';
import logger from '@greenlight/logger';

const { publicRuntimeConfig } = getConfig();
const environment = get(publicRuntimeConfig, 'nodeEnv', 'dev');

const commonPageNames = {
  setplan: 'set_plan',
  addchild: 'add_child_info',
  verifyidentity: 'set_legal_first_name',
  creditapplication: 'credit_application',
  fundwallet: 'set_initial_funding_amount',
  fundingaccount: 'set_funding_account'
};

const addToAnswers = (
  question: string,
  answers: any[],
  phoneNumber: string,
  plan: string
) => {
  switch (question) {
    case 'set_user_email':
      answers.push(`${phoneNumber}shortcuttest@greenlight.me`);
      break;
    case 'set_user_password_and_confirm':
    case 'set_user_password':
      answers.push('greenlight1');
      break;
    case 'set_parental_unit_name':
      answers.push('parental figure');
      break;
    case 'set_referral_code':
      answers.push('');
      break;
    case 'set_plan':
      let validPlan = plan;
      if (['standard', 'infinity', 'max'].indexOf(plan) === -1) {
        validPlan = 'standard';
      }
      answers.push(validPlan);
      break;
    case 'add_child_info':
      answers.push([
        {
          dob: '05/05/2010',
          firstName: 'Test',
          gender: 'male',
          isNonAppUser: true,
          lastName: 'Child'
        }
      ]);
      break;
    case 'credit_application':
      answers.push({
        credit_accepted: false,
        credit_decision: 'credit_skipped'
      });
      break;
    case 'set_legal_first_name':
      answers.push('John');
      break;
    case 'set_legal_last_name':
      answers.push('Smith');
      break;
    case 'set_shipping_address':
    case 'set_legal_address':
      answers.push({
        address: '303 Peachtree Place',
        address2: '',
        city: 'Atlanta',
        state: 'GA',
        zip: '30318'
      });
      break;
    case 'set_user_date_of_birth':
      answers.push('02/28/1975');
      break;
    case 'set_user_ssn_last4':
      answers.push('3333');
      break;
    case 'accept_terms':
      answers.push(true);
      break;
    case 'set_initial_funding_amount':
      answers.push(20.0);
      break;
    default:
      break;
  }
};

function registrationShortcut(
  phoneNumber: string,
  registrationToken: string,
  shortcutQuestion: string,
  flow: string | number,
  shortcutPlan: string,
  answer: (arg: any) => void,
  parentNameAnswer?: string | undefined
) {
  const allowedEnvironments = ['dev', 'development', 'local', 'staging', 'qa'];
  const answers: any[] = [];

  // This is only meant for lower environments, so if someone comes from production we will return here and not submit anything
  if (allowedEnvironments.indexOf(environment) === -1) {
    return;
  }
  let question = shortcutQuestion;
  let plan = shortcutPlan;

  // Get question and plan from parentName answer if it was submitted there
  // Example: parentNameAnswer being shortcut=fundwallet&plan=max will make question = fundwallet and plan = max
  if (parentNameAnswer) {
    question =
      parentNameAnswer.indexOf('&') !== -1
        ? parentNameAnswer.substring(
            parentNameAnswer.indexOf('=') + 1,
            parentNameAnswer.indexOf('&')
          )
        : parentNameAnswer.substring(parentNameAnswer.indexOf('=') + 1);

    plan =
      parentNameAnswer.indexOf('&') !== -1
        ? parentNameAnswer.substring(parentNameAnswer.indexOf('plan=') + 5)
        : '';
  }

  const lowerCaseQuestion = question.toLowerCase();
  const regQuestion = commonPageNames[lowerCaseQuestion] || lowerCaseQuestion;

  // Take flow and create a single array of questions with prove filtered out
  const flowQuestions = ([] as string[]).concat(
    ...flows[flow].filter(
      (q: string) => q !== 'prove_prefill' && q !== 'prove_review'
    )
  );

  // Add Shipping Address question to flow(not a part of flow in db but must be answered with legal address)
  flowQuestions.splice(
    flowQuestions.indexOf('set_legal_address') + 1,
    0,
    'set_shipping_address'
  );

  if (flowQuestions.indexOf(regQuestion) === -1) {
    logger.info(
      `${regQuestion} is not a part of ${flow}, unable to shortcut registration`
    );
    return;
  }

  let i = 0;
  while (i < flowQuestions.length) {
    if (flowQuestions[i] === regQuestion) {
      break;
    } else {
      addToAnswers(flowQuestions[i], answers, phoneNumber, plan);
      i += 1;
    }
  }

  flowQuestions.length = flowQuestions.indexOf(regQuestion);

  answer({ accessToken: registrationToken, questions: flowQuestions, answers });
}

export default registrationShortcut;
